import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiListDataService } from './api.list-data.service';
import { AppointmentPatchModel, AppointmentVerifyResponse } from '../../models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ApiAppointmentPatchService extends ApiListDataService<AppointmentPatchModel, any> {
    constructor(http: HttpClient) {
        super(http, '/Appointment/');
    }

    public verifyByIds(ids: number[]): Observable<AppointmentVerifyResponse> {
        return this.createItemParams(`BulkVerify `, ids);
    }
}
